import React from 'react';
import withIcon from '../utilities/withIcon';

const IconUsers = () => {
  return (
    <g>
      <path d="m4.3755 11.1333-.9423-.9483a.4476.4476 0 0 0 -.5813-.0726c-1.6744 1.0883-2.7756.16-2.7756 3.3421h4.2764a7.1494 7.1494 0 0 1 .2781-2.2245c-.0054 0-.0081.0039-.0135.0039a.3763.3763 0 0 1 -.2418-.1006z" />
      <path d="m12.6417 9.503a.529.529 0 0 0 -.6873.0859l-1.1139 1.1211a.4027.4027 0 0 1 -.5718 0l-1.1141-1.1211a.5291.5291 0 0 0 -.6873-.0859c-1.98 1.2867-3.2817.1893-3.2817 3.9515h10.738c0-3.7623-1.3018-2.6645-3.2819-3.9515z" />
      <path d="m4.6172 9.3914c1.6375 0 2.497-2.5742 1.8393-4.0182a1.9705 1.9705 0 0 0 -1.8393-1.1452 1.9705 1.9705 0 0 0 -1.8392 1.1453c-.658 1.444.202 4.0181 1.8392 4.0181z" />
      <path d="m10.5546 8.65c1.9361 0 2.9523-3.0435 2.1747-4.7509a2.33 2.33 0 0 0 -2.1747-1.3541 2.33 2.33 0 0 0 -2.1746 1.355c-.7776 1.707.2385 4.75 2.1746 4.75z" />
    </g>
  );
};

export default withIcon(IconUsers);
